// Meta event helpers used to coordinate browser-side Pixel events with
// server-side Conversions API events.
//
// Browser Pixel base + initial PageView is loaded in public/index.html.
// metaPixel.js wraps fbq() with typed helpers. THIS module adds:
//   - generateMetaEventId()   → uuid4 used as Pixel `eventID` + CAPI `event_id`
//   - getMetaCookies()        → reads _fbp and _fbc first-party cookies

export function generateMetaEventId() {
  if (typeof window === "undefined") return "";
  try {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
  } catch {
    /* fall through */
  }
  // Fallback: timestamp + random; not RFC4122 but unique enough for dedup keys.
  return `evt-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function readCookie(name) {
  if (typeof document === "undefined" || !document.cookie) return null;
  const cookies = document.cookie.split(";");
  for (const raw of cookies) {
    const eq = raw.indexOf("=");
    if (eq < 0) continue;
    const k = raw.slice(0, eq).trim();
    if (k === name) {
      return decodeURIComponent(raw.slice(eq + 1).trim());
    }
  }
  return null;
}

export function getMetaCookies() {
  return {
    fbp: readCookie("_fbp"),
    fbc: readCookie("_fbc"),
  };
}
